export default {
  minWidth1281: '@media (min-width: 1281px)',
  minWidth1920: '@media (min-width: 1920px)',
  minWidth2560: '@media (min-width: 2560px)',
};
